interface AuthCookieOptions {
  secure: boolean
  httpOnly: false
  maxAge: number
  sameSite: 'lax'
}

export function getAuthCookieOptions(maxAge: number): AuthCookieOptions {
  const isSecure = import.meta.client
    ? window.location.protocol === 'https:'
    : process.env.NODE_ENV === 'production'

  return {
    secure: isSecure,
    httpOnly: false,
    maxAge,
    sameSite: 'lax',
  }
}
